import * as React from 'react';
import { Faq } from '../models';
import FaqItem from './FaqItem';

const FaqItemList: React.SFC<{ selectedFaqTopic; faqs }> = (props) => {
  return props.faqs.map((question: Faq, index: number) => (
    <FaqItem key={index} selectedFaqTopic={props.selectedFaqTopic} {...question} />
  ));
};

export default FaqItemList;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/FaqItemList.tsx